// extracted by mini-css-extract-plugin
module.exports = {"heading":"_31Fp7NmI m0 p0 bold"};